module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAANlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3dmhyAAAAEnRSTlMA/xA/0KBgz/AwcIAgwFCQ36/c+6O/AAAAqklEQVR4nOXUuxKEIAwF0ATBVYF9/P/PbhIYxspcCxu9jRZnmBAC9OSEF88nLKPaLKjVpnXBdGKuRKAO0ZjqtyPz0Fmq8eoVYHpmjsHtQ9eIlUq79m1SZhqwbVH9IHZoyBJtUL3tF+rZXS19TliqHGFLzDLDoF37hUCsoiK7dM/YIvvLv6876y3VHgnMGo5pmwBKVEB3acrkRNo6Ijf/OMsO22tylD43d88fmBsEtzSTDLwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book.png
// module id = jWGT
// module chunks = 5